import {
  Controller
} from "@hotwired/stimulus"
import {
  put,
  patch
} from '@rails/request.js'
import {
  debugLog,
  errorLog
} from '../debug'

export default class extends Controller {
  static targets = ["editable", "reset", "wrapper", "supplierValue"]
  static values = {
    supplier: String,
    initial: String,
    fieldType: String,
    path: String,
    twodfields: Array
  }

  connect() {
    //   this.wrapperTarget.classList.add('touched')
    this.edit()
    this.fieldType = this.editableTarget.getAttribute('data-field-type')
  }

  edit() {
    this.editableTarget.classList.add('editable')
    this.editableTarget.readOnly = false
  }

  async overwrite() {
    let subm_value = ''
    if (this.editableTarget.matches('[type="checkbox"]')) {
      subm_value = this.editableTarget.checked ? 'on' : 'off'
    } else {
      subm_value = this.editableTarget.value
    }

    // debugLog(`overwrite field ${this.editableTarget.id} with ${subm_value}, name: ${this.editableTarget.name}, match ${this._fieldname(this.editableTarget.name)} \n initialValue: ${this.initialValue}`)

    if (subm_value == this.initialValue) {
      this.reset()
      return
    }

    const field_name = this._fieldname(this.editableTarget.name)

    const overwrite_body = JSON.stringify({
      production_profile: {
        [this.editableTarget.getAttribute('data-product-type')]: {
          [field_name]: subm_value
        }
      }
    })

    this.send_update(overwrite_body)
  }

  async overwrite_2d() {
    const initial_vals = JSON.parse(this.initialValue)
    let subm_values = {}
    const wt = this.wrapperTarget

    Object.keys(initial_vals).forEach((key) => {
      let fieldname = this._fieldname(wt.querySelector(`.${key}-value`).name)
      let subm_name = wt.querySelector(`.${key}-value`).name
      subm_values[fieldname] = wt.querySelector(`.${key}-value`).value
      debugLog(`overwrite wrapper ${wt.id}, field ${fieldname} with ${subm_values[fieldname]}`)
    })

    const overwrite_body = JSON.stringify({
      production_profile: {
        [this.editableTarget.getAttribute('data-product-type')]: subm_values
      }
    })

    this.send_update(overwrite_body)

  }

  async send_update(overwrite_body) {
    debugLog('send_update body:', overwrite_body)

    this.removeHighlighting()
    this.waiting()

    const url = `/admin/production_profiles/${this.supplierValue}`
    try {
      // TODO: field readonly
      // TODO: show spinner

      const response = await put(url, {
        body: overwrite_body,
        contentType: "application/json",
        responseKind: "json"
      })
      if (!response.ok) {
        this.markFaulty()
        throw new Error(`Response status: ${response.status}, data: ${response.data}`);
      }

      if (response.ok) {
        this.markOverwritten()

        this.dispatch("field_update")
          // bubble up event to retry dependencies
      }
      // TODO: field not readonly anymore
      // TODO: show OK
    } catch (error) {
      errorLog(error);
    }

  }

  async reset() {
    debugLog(`reset field ${this.supplierValue} with ${this.editableTarget.value}, name: ${this.editableTarget.name}, match ${this.editableTarget.name.match("\\[(.*)]")}`)

    const field_name = this._fieldname(this.editableTarget.name)
    const url = `/admin/production_profiles/${this.supplierValue}/reset_override`

    let fields = {}
    if (this.twodfieldsValue.length > 0) {
      this.twodfieldsValue.forEach((field) => {
        fields[this.pathValue + '.' + field] = 'undefined'
      })
    } else {
      fields[field_name] = 'undefined'
    }

    const reset_body = JSON.stringify({
      production_profile: {
        [this.editableTarget.getAttribute('data-product-type')]: fields
      }
    })

    try {
      // TODO: field readonly
      // TODO: show spinner

      const response = await put(url, {
        body: reset_body,
        contentType: "application/json",
        responseKind: "json"
      })

      if (!response.ok) {
        this.markFaulty()
        throw new Error(`Response status: ${response.status}, data: ${response.data}`);
      }

      this.resetField()
      this.dispatch("field_update")
        // TODO: field not readonly anymore
        // TODO: show OK

    } catch (error) {
      errorLog(error.message);
    }
  }

  markOverwritten() {
    this.wrapperTarget.setAttribute('data-overwritten', true)
    this.wrapperTarget.classList.add('overwritten')
    this.wrapperTarget.classList.add('highlight')
    this.supplierValueTarget.classList.remove('hidden')
  }

  markFaulty() {
    this.wrapperTarget.classList.add('error')
  }

  resetField() {
    this.removeHighlighting()

    if (this.fieldType == "checkbox") {
      this.editableTarget.checked = (this.initialValue == 'on')
    } else if (this.fieldType == "two_d_size") {
      this._reset_2d_field()
    } else if (this.fieldType == "min_max_range") {
      this._reset_2d_field()
    } else {
      this.editableTarget.value = this.initialValue
    }
    this.unmarkOverwritten()
  }

  // TODO:
  waiting() {
    this.editableTarget.classList.add('waiting')
  }

  removeHighlighting() {
    this.supplierValueTarget.classList.add('hidden')
    this.wrapperTarget.classList.remove('highlight')
  }

  unmarkOverwritten() {
    this.editableTarget.classList.remove('overwritten')
    this.wrapperTarget.classList.remove('overwritten')
    this.wrapperTarget.setAttribute('data-overwritten', false)
  }

  _reset_2d_field() {
    const initial_vals = JSON.parse(this.initialValue)
    const wt = this.wrapperTarget

    Object.keys(initial_vals).forEach(function(key) {
      wt.querySelector(`.${key}-value`).value = initial_vals[key]
    })
  }

  _fieldname(elem) {
    return elem.match("\\[(.*)]")[1]
  }
}